<template>
  <div v-visibility-change="visibilityChange">
    <b-loading
      class="xb-loading"
      :is-full-page="true"
      :active.sync="isApplicationLoading"
      :can-cancel="false"
      style="z-index: 27;"
    />

    <template v-if="isPublicHeader || isInMaintenancePage">
      <public-header
        placeholder="e.g. Anneas"
        :options="options"
        :navs="computedNavs"
        :filteredDataObj="filteredDataObj"
        :field="field"
        :srcRedirect="srcRedirect"
        :googleSearchUrl="googleSearchUrl"
        :showLogoOnly="isInMaintenancePage"
        @searchIconClick="searchIconClick"
        @onChange="onChange"
      />
    </template>
    <template v-else>
      <XbaseHeader
        v-if="$route.name !== 'Login' && idleChecked && tokenCheck"
        @logout="signedOutTriggered"
      />
    </template>

    <countdown
      v-if="signedIn && !isReminded"
      :time="timeToDisplayNotification"
      ref="countdown"
      @end="displaySessionMaxReminder"
    />

    <countdown
      v-if="signedIn && renewTokenInitiated && !wasIdle && tokenCheck"
      ref="countdownRenew"
      :time="idpRenewAccessTokenMs"
      @progress="saveProgress"
      @end="setupRenewTokenInterval"
    />
    <router-view @logout="signedOutTriggered" v-if="idleChecked" />
  </div>
</template>

<script>
import XbaseHeader from "./components/shared/xbase-header/XbaseHeader.vue";
import Mgr from "./services/securityService.js";

import VueCountdown from "@chenfengyuan/vue-countdown";
// Utility functions
const mapState = window.Vuex.mapState;

export default {
  name: "CommonApp",
  components: {
    XbaseHeader,
    countdown: VueCountdown
  },

  data() {
    return {
      isVisible: true,
      mgr: null,
      isSignedOutTriggered: false,
      navs: [
        {
          title: "PUBLIC REGISTER",
          href: `/aceas/public-register/sales/1`,
          target: { path: "/public-register/sales/1" },
          isActive: true
        },
        {
          title: "SUSPENDED/REVOKED SALESPERSONS & ESTATE AGENTS",
          href: `/aceas/suspended-or-revoked-salespersons-&-estate-agents/suspended-sales`,
          target: {
            path:
              "/suspended-or-revoked-salespersons-&-estate-agents/suspended-sales"
          },
          isActive: false
        }
      ],
      navsSecondary: [
        {
          title: "FEEDBACK MANAGEMENT",
          href: "/feedback-management",
          isActive: true
        },
        {
          title: "FEEDBACK FORM",
          href: "/feedback-management/feedback-form",
          isActive: false
        },
        {
          title: "COMPLAINT FORM",
          href: "/feedback-management/complaint-form",
          isActive: false
        }
      ],
      name: "",
      field: "user.first_name",
      options: [
        { user: { first_name: "ulala" } },
        { user: { first_name: "kfahwigwibg" } },
        { user: { first_name: "udawda" } }
      ],
      srcRedirect: {
        logoSrc: "/aceas/assets/common/vendor/xbase/img/cea-logo2.png",
        logoHref: "https://www.cea.gov.sg/",
        srcPrint: "/aceas/assets/common/vendor/xbase/img/util-print.png"
      },
      renewTokenInitiated: true,
      idpRenewAccessTokenMs:
        this.$store.state.config.configurationData.common_module.commonConfig
          .idpRenewAccessTokenMs || 30000,
      renewTokenCookieKey: "timeInMs",
      idleChecked: false,
      lastUnloadActivityKey: "lastUnloadActivity",
      lastRefreshKey: "lastRefreshActivity",
      bc: null
    };
  },

  onIdle() {
    if (
      this.signedIn &&
      (this.isVisible ||
        (!this.$store.state.auth.wasIdle &&
          !this.$store.state.auth.anyActiveTab))
    ) {
      this.bc.postMessage("setWasIdle");
      this.triggerIdle();
    }
  },

  watch: {
    isSessionActive(val) {
      if (
        val === false &&
        this.sessionExpirationMaxTime + this.loginTime > new Date().getTime() &&
        !this.isSignedOutTriggered &&
        this.$route.meta.requiresAuth &&
        this.signedIn
      ) {
        this.bc.postMessage("isSessionActive");
        this.triggerAnotherLogin();
      }
    },

    isVisible(val) {
      this.$store.commit("auth/setAnyActiveTab", val);
    },

    $route(to, from) {
      if (from.name === "OidcCallback" && this.signedIn) {
        this.instantiateMgr();
        this.attachMgrEvents();
      }
    }
  },

  created() {
    this.$store.dispatch("prompt/fetchPromptsList", "CEA-PR-23");
    this.instantiateMgr();
    if (this.signedIn) {
      this.attachMgrEvents();
    }
  },

  computed: {
    ...mapState({
      signedIn: state => state.auth.signedIn,
      isSessionActive: state => state.auth.isSessionActive,
      isApplicationLoading: state => state.global.isApplicationLoading,
      loginTime: state => state.auth.loginTime,
      isReminded: state => state.auth.isReminded,
      sessionExpirationMaxTime: state => state.auth.sessionExpirationMaxTime,
      beforeSessionExpirationMaxNotificationTime: state =>
        state.auth.beforeSessionExpirationMaxNotificationTime,
      isManuallySignedOut: state => state.auth.isManuallySignedOut,
      wasIdle: state => state.auth.wasIdle,
      accessToken: state => state.auth.accessToken,
      tokenCheck: state => state.auth.tokenCheck
    }),
    promptList() {
      return this.$store.getters["prompt/promptList"];
    },
    timeToDisplayNotification() {
      const maxSessionTime = this.sessionExpirationMaxTime;
      const notificationTimeBeforeMax = this
        .beforeSessionExpirationMaxNotificationTime;

      const now = new Date().getTime();
      const timeToDisplayNotification =
        this.loginTime + maxSessionTime - notificationTimeBeforeMax; //change this with common config json 300000

      return timeToDisplayNotification - now;
    },
    isPublicHeader() {
      if (
        this.$route.path.includes("/public-register") ||
        this.$route.path.includes(
          "/suspended-or-revoked-salespersons-&-estate-agents"
        ) ||
        (this.$route.path.includes("/feedback-management") && !this.signedIn)
      ) {
        return true;
      } else {
        return false;
      }
    },
    computedNavs() {
      const isExact = this.$route.path;
      const newNav = [];
      this.navs.map(item => {
        if (isExact.includes("public-register")) {
          if (item.href.includes("public-register")) {
            newNav.push({ ...item, isActive: true });
          } else {
            newNav.push({ ...item, isActive: false });
          }
        } else if (
          isExact.includes("suspended-or-revoked-salespersons-&-estate-agents")
        ) {
          if (
            item.href.includes(
              "suspended-or-revoked-salespersons-&-estate-agents"
            )
          ) {
            newNav.push({ ...item, isActive: true });
          } else {
            newNav.push({ ...item, isActive: false });
          }
        }
      });

      const feedbackNavs = [
        {
          title: "FEEDBACK MANAGEMENT",
          href: `/aceas/feedback-management`,
          target: { path: "/feedback-management" },
          isActive: true
        }
      ];

      return isExact.includes("feedback-management") ? feedbackNavs : newNav;
    },
    filteredDataObj() {
      return this.options.filter(option => {
        return (
          option.user.first_name
            .toString()
            .toLowerCase()
            .indexOf(this.name.toLowerCase()) >= 0
        );
      });
    },
    googleSearchUrl() {
      return this.$store.state.config.configurationData
        ? this.$store.state.config.configurationData.common_module
          ? this.$store.state.config.configurationData.common_module
              .commonConfig
            ? this.$store.state.config.configurationData.common_module
                .commonConfig.googleSearchId
            : "Null"
          : "Null"
        : "Nul";
    },
    isInMaintenancePage() {
      return this.$route.name === "maintenance";
    }
  },

  async mounted() {
    try {
      this.$store.commit("setApplicationLoadingToTrue");
      // Add BroadcastChannel to trigger isSessionActive or idle
      // might need improvement later
      this.bc = new BroadcastChannel("aceas_channel");
      this.bc.onmessage = event => {
        switch (event.data) {
          case "setWasIdle":
            this.triggerIdle();
            return;

          case "isSessionActive":
            this.triggerAnotherLogin();
            return;
        }
      };

      if (this.signedIn || this.wasIdle) {
        this.checkDiffTimeInMs();
        if (!this.isReminded && this.$refs.countdown) {
          this.$refs.countdown.start();
        }

        if (this.isReachMaxAbsoluteSession() === true) {
          this.$store.commit("auth/setIsManuallySignedOut", false);
          this.signedOutTriggered(true);
          this.mgr?.signOut();
        } else if (
          this.sessionExpirationMaxTime + this.loginTime >
          new Date().getTime()
        ) {
          if (this.isSessionActive === false && !this.isSignedOutTriggered) {
            this.$store.commit("auth/setIsManuallySignedOut", false);
            this.mgr?.signOut();
          }
        }

        if (!this.wasIdle) {
          await this.diffActiveTimeWithMaxIdle();
        }
      }

      this.displayAppsVisibility();
    } catch {
      this.displayAppsVisibility();
    }
  },

  methods: {
    setToDefaultRenewAccessTokenMs() {
      this.idpRenewAccessTokenMs =
        this.$store.state.config.configurationData.common_module.commonConfig
          .idpRenewAccessTokenMs || 30000;
    },
    checkDiffTimeInMs() {
      const now = Date.now();

      const timeInMs = this.getCookie(this.renewTokenCookieKey);
      if (timeInMs) {
        // User has visited
        var time = parseInt(timeInMs);
        var delta = now - time;
        if (delta < this.idpRenewAccessTokenMs) {
          this.idpRenewAccessTokenMs = this.idpRenewAccessTokenMs - delta;
        } else {
          this.setToDefaultRenewAccessTokenMs();
        }
      }
    },
    async diffActiveTimeWithMaxIdle() {
      const toleranceValue = 60000; // in ms
      const idpSessionIdleTime = this.$store.state.config.configurationData
        .common_module.commonConfig.idpSessionIdleTime;
      const lastUnloadActivity = parseInt(
        this.getCookie(this.lastUnloadActivityKey)
      );

      if (
        Date.now() - lastUnloadActivity >=
        idpSessionIdleTime - toleranceValue
      ) {
        await this.accessTokenRenewalHandler();
      }
    },
    displayAppsVisibility() {
      this.$store.commit("setApplicationLoadingToFalse");
      this.setIdleChecked(true);
    },
    setIdleChecked(value) {
      this.idleChecked = value;
    },
    triggerIdle() {
      this.$store.commit("auth/setWasIdle", true);
      this.$store.commit("auth/setSignedIn", false);

      if (this.$route.meta.requiresAuth) {
        this.$router.push({ name: "Login" });
      }
    },
    triggerAnotherLogin() {
      this.$buefy.dialog.alert({
        message:
          "<h2 class='is-danger'>Error</h2> Another login session has been detected. Please re-login to continue",
        type: "is-danger",
        hasIcon: true,
        icon: "times",
        iconPack: "fa",
        onConfirm: () => {
          this.$store.commit("auth/setIsManuallySignedOut", true);
          location.reload();
        }
      });
    },
    async accessTokenRenewalHandler() {
      const kickedRelatedMessage = [
        "Offline user session not found",
        "Session not active"
      ];
      const inactivityRelatedMessage = [
        "Maximum allowed refresh token reuse exceeded",
        `Session doesn't have required client`,
        `Invalid refresh token`,
        "Token is not active"
      ];
      await this.mgr
        .renewToken()
        .then(() => {
          this.setToDefaultRenewAccessTokenMs();
        })
        .catch(e => {
          const errorMessage = e.message;
          if (kickedRelatedMessage.includes(errorMessage))
            this.$store.commit("auth/setIsSessionActive", false);
          else if (inactivityRelatedMessage.includes(errorMessage)) {
            this.triggerIdle();
          }

          this.displayAppsVisibility();
        });
    },
    visibilityChange(evt, hidden) {
      if (this.signedIn) {
        if (!hidden) {
          this.isVisible = true;
          this.$store.commit("auth/setAnyActiveTab", true);
          this.renewTokenInitiated = true;

          this.diffActiveTimeWithMaxIdle();
        } else {
          this.isVisible = false;
          this.$store.commit("auth/setAnyActiveTab", false);
          this.renewTokenInitiated = false;

          document.cookie = `${
            this.lastUnloadActivityKey
          }=${Date.now()};path=/`;
        }
      }
    },

    isReachMaxAbsoluteSession() {
      const toleranceValue = 60; //  to allow the current time to deviate when validating (in seconds)

      return (
        Math.floor((this.sessionExpirationMaxTime + this.loginTime) / 1000) <
        Math.floor(new Date().getTime() / 1000) + toleranceValue
      );
    },

    signedOutTriggered(value) {
      this.isSignedOutTriggered = value;
    },

    displaySessionMaxReminder() {
      this.$store.commit("auth/setIsReminded", true);
      if (
        this.sessionExpirationMaxTime + this.loginTime >
        new Date().getTime()
      ) {
        this.$buefy.dialog.confirm({
          message: `<h2 class='is-danger'>Your session is about to expire in ${this.msToTime(
            this.beforeSessionExpirationMaxNotificationTime
          )}</h2>`,
          confirmText: "OK",
          type: "is-danger",
          canCancel: false,
          hasIcon: true
        });
      }
    },
    searchIconClick() {},
    onChange(val) {
      this.name = val;
    },
    msToTime(ms) {
      let seconds = (ms / 1000).toFixed();
      let minutes = (ms / (1000 * 60)).toFixed();
      let hours = (ms / (1000 * 60 * 60)).toFixed();
      if (seconds < 60) return seconds + ` second${seconds < 2 ? "" : "s"}`;
      else if (minutes < 60)
        return minutes + ` minute${minutes < 2 ? "" : "s"}`;
      else return hours + ` hour${hours < 2 ? "" : "s"}`;
    },
    instantiateMgr() {
      this.mgr = new Mgr(
        this.$store.state.config.configurationData.common_module
      );
    },
    attachMgrEvents() {
      const self = this;

      // this.mgr.mgr.events.addAccessTokenExpiring(function() {
      //   const currentTimeInUnixSecond = Math.floor(new Date().getTime() / 1000);

      //   if (
      //     Math.floor((self.loginTime + self.sessionExpirationMaxTime) / 1000) -
      //       self.$store.state.config.configurationData.common_module
      //         .commonConfig.idpAccessTokenExpiringNotificationTime >=
      //     currentTimeInUnixSecond
      //   ) {
      //     self.mgr.renewToken().catch(() => {
      //       if (self.isReachMaxAbsoluteSession() === true) {
      //         self.$buefy.dialog.alert({
      //           message: self.promptList["CEA-PR-23"]
      //             ? self.promptList["CEA-PR-23"].content
      //             : "<h2 class='is-danger'>Internet Session Timeout</h2> Your session has expired. Please relog in to continue.",
      //           type: "is-danger",
      //           hasIcon: true,
      //           icon: "times",
      //           iconPack: "fa",
      //           onConfirm: () => {
      //             self.$store.commit("auth/setIsManuallySignedOut", true);
      //             location.reload();
      //           }
      //         });
      //       } else {
      //         self.$store.commit("auth/setIsSessionActive", false);
      //       }
      //     });
      //   }
      // });

      this.mgr.mgr.events.addAccessTokenExpired(function() {
        self.mgr.renewToken().catch(() => {
          if (self.isReachMaxAbsoluteSession() === true) {
            self.$buefy.dialog.alert({
              message: self.promptList["CEA-PR-23"]
                ? self.promptList["CEA-PR-23"].content
                : "<h2 class='is-danger'>Internet Session Timeout</h2> Your session has expired. Please relog in to continue.",
              type: "is-danger",
              hasIcon: true,
              icon: "times",
              iconPack: "fa",
              onConfirm: () => {
                self.$store.commit("auth/setIsManuallySignedOut", true);
                location.reload();
              }
            });
          } else if (
            self.sessionExpirationMaxTime + self.loginTime >
            new Date().getTime()
          ) {
            self.$store.commit("auth/setIsSessionActive", false);
          }
        });
      });

      this.mgr.mgr.events.addSilentRenewError(function() {
        self.$store.commit("auth/setIsManuallySignedOut", false);
        self.mgr.signOut();
      });

      this.mgr.mgr.events.addUserSignedOut(function() {});
    },
    setupRenewTokenInterval() {
      if (this.isSessionActive && this.signedIn) {
        const self = this;
        const executeCallback = function() {
          document.cookie = `${self.lastRefreshKey}=${Date.now()};path=/`;
          self.mgr.renewToken().catch(() => {
            if (self.isReachMaxAbsoluteSession() === true) {
              self.$buefy.dialog.alert({
                message: self.promptList["CEA-PR-23"]
                  ? self.promptList["CEA-PR-23"].content
                  : "<h2 class='is-danger'>Internet Session Timeout</h2> Your session has expired. Please relog in to continue.",
                type: "is-danger",
                hasIcon: true,
                icon: "times",
                iconPack: "fa",
                onConfirm: () => {
                  self.$store.commit("auth/setIsManuallySignedOut", true);
                  location.reload();
                }
              });
            } else {
              self.$store.commit("auth/setIsSessionActive", false);
            }
          });
          self.setToDefaultRenewAccessTokenMs();
        };

        const now = Date.now();

        const lastRefreshTime = this.getCookie(self.lastRefreshKey);
        if (lastRefreshTime) {
          // User has visited
          var time = parseInt(lastRefreshTime);
          var delta = now - time;
          if (delta >= this.idpRenewAccessTokenMs) {
            executeCallback();
          }
        } else {
          executeCallback();
        }

        this.renewTokenInitiated = false;
        setTimeout(() => {
          this.renewTokenInitiated = true;
        }, 100);
      }
    },
    saveProgress() {
      if (this.isSessionActive && this.signedIn) {
        document.cookie = `${this.renewTokenCookieKey}=${Date.now()};path=/`;
      }
    },
    getCookie(cname) {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }
  }
};
</script>
